import type { IDirectionDetails } from '../../../../models/direction-details';

export class DirectionDetails {
  public static mapToBusinessModel(apiModel: DirectionDetails): IDirectionDetails {
    return {
      fullDirection: apiModel.fullDirection ?? '',
      isFrontEntry: apiModel.isFrontEntry,
      shortDirection: apiModel.shortDirection ?? '',
      via: apiModel.via,
    };
  }

  public fullDirection?: string;
  public shortDirection?: string;
  public replaces?: string;
  public via?: string;
  public isFreeService?: boolean;
  public isPaidService?: boolean;
  public isSwimmingService?: boolean;
  public isDirectDestinationBus?: boolean;
  public isFrontEntry?: boolean;
  public isExtraBus?: boolean;
  public isExtraBoat?: boolean;
  public isExtraTram?: boolean;
  public isSchoolBus?: boolean;
  public isExpressBus?: boolean;
  public fortifiesLine?: boolean;
}
